import { MOBILE_WEB_URL } from 'common/constants'
import { IDefaultSearchBarAction } from 'services/Search/strategies/search-bar-actions/interface'

function responsiveAction({
  defaultAction,
}: IDefaultSearchBarAction): Function {
  const screenWidth = window.innerWidth

  if (screenWidth < 768) {
    window.location.assign(`${MOBILE_WEB_URL}/search`)
    return null
  }
  return defaultAction()
}

export default responsiveAction
